'use strict';

angular.module('randomization').controller('RecordRandomizationController', [
    '$exceptionHandler',
    '$q',
    '$rootScope',
    'RecordRandomizationService',
    'RecordService',
    'CrdConfigurationService',
    'ErrorMessages',
    'InetsysMessages',
    'gettext',
    'RecordsManagerService',
    'AccountManager',
    'Event',
    'CoreRecordData',
    'RecordDataService',
    'RecordMetadataService',
    'Modal',
    'RecordRulesService',
    'ShareCrfApiErrorCodes',
    'FieldsCompletionService',
    'RecordValidationService',
    '$injector',
    function(
        $exceptionHandler,
        $q,
        $rootScope,
        RecordRandomizationService,
        RecordService,
        CrdConfigurationService,
        ErrorMessages,
        InetsysMessages,
        gettext,
        RecordsManagerService,
        AccountManager,
        Event,
        CoreRecordData,
        RecordDataService,
        RecordMetadataService,
        Modal,
        RecordRulesService,
        ShareCrfApiErrorCodes,
        FieldsCompletionService,
        RecordValidationService,
        $injector
    ) {
        var vm = this;

        var recordId = RecordService.getId();

        vm.error = null;

        // Permisos generales, a.k.a routes
        vm.permissions = {
            read: AccountManager.hasPermission('read randomization'),
            readCode: AccountManager.hasPermission('read randomization code'),
            readMasked: AccountManager.hasPermission('read randomization masked'),
            readLabel: AccountManager.hasPermission('read randomization label'),
            readBranch: AccountManager.hasAtLeastOnePermission([
                'read randomization code',
                'read randomization masked',
                'read randomization label',
            ]),
            unblind: AccountManager.hasPermission('unblind records'),
            randomize: AccountManager.hasPermission('randomize records'),
            readUnblind: AccountManager.hasPermission('read unblind records'),
            readRevision: AccountManager.hasPermission('read records revision'),
        };

        // Entity notes
        vm.randomization = RecordRandomizationService.get();
        vm.isRandomized = RecordRandomizationService.isRandomized();

        vm.entityLabel = CrdConfigurationService.getLabelSingular();

        // Si se ha revelado el ciego esta variable albergará los datos de aleatorización
        vm.unblinded = null;

        vm.hasCohort = false;

        // Para que la cohorte sea válida todos los campos implicados deben tener un valor
        vm.emptyCohortFields = false;

        // Datos de la cohorte para consultar
        vm.readableCohort = [];

        // Registro de las revelaciones de ciego
        vm.revelations = [];
        vm.visibleRevelations = false;

        // Se pone a verdadero cuando han terminado las comprobaciones iniciales, por ejemplo reglas de tipo "bloquear
        // aleatorización"
        vm.ready = false;

        // Mensaje de bloqueo de la operación de aleatorizar, viene de una regla en la inicialización del componente
        vm.blockedMessage = null;

        var _hasQueries = CrdConfigurationService.hasQueries();

        var RevisionCount = null;
        if (CrdConfigurationService.hasRevisionStates() && vm.permissions.readRevision) {
            RevisionCount = $injector.has('RevisionCount') ? $injector.get('RevisionCount') : null;
        }

        vm.loading = true;
        vm.$onInit = function() {
            var randomizationConfig = CrdConfigurationService.getRandomization();
            if (randomizationConfig.getType() === 'block') {
                var cohortConfig = randomizationConfig.getCohorts() || {};
                var cohortFields = cohortConfig.fields || [];

                vm.hasCohort = cohortFields.length > 0;
                vm.emptyCohortFields = false;

                vm.readableCohort = cohortFields.map(function(fieldId) {
                    if (!vm.emptyCohortFields) {
                        vm.emptyCohortFields = CoreRecordData.isFieldValueEmpty(fieldId) || CoreRecordData.isFieldValueMissingOrUnknown(fieldId);
                    }

                    return {
                        path: CoreRecordData.getElementFullLabeledPathByUID(fieldId).join(' > '),
                        value: CoreRecordData.getReadableFieldValue(fieldId),
                    };
                });
            }
            else {
                vm.hasCohort = false;
            }

            _reloadRevelations()
                .then(function() {
                    vm.loading = false;
                })
                .catch(function(error) {
                    vm.loading = false;

                    return $exceptionHandler(error, 'reload revelations');
                });

            _checkBlockedByRule();

            vm.ready = true;
        };

        /**
         * Reload revelations
         *
         * @return {Promise} revelations
         */
        function _reloadRevelations() {
            var promise;

            if (vm.permissions.readUnblind) {
                promise = RecordRandomizationService.getRevelations()
                    .then(function(revelations) {
                        vm.revelations = revelations;
                    });
            }
            else {
                promise = $q.resolve();
            }

            return promise;
        }

        vm.isRecordLocked = function() {
            return CrdConfigurationService.getStates().hasRecordLock() && RecordMetadataService.isRecordLocked();
        };

        // Aleatorizar un paciente
        vm.randomize = function() {
            if (vm.loading || vm.blockedMessage || vm.isRecordLocked()) {
                return;
            }

            vm.loading = true;

            return Event.broadcast('randomizeRecordActionStart', [recordId])
                .then(function(event) {
                    if (!event.defaultPrevented) {
                        var params = {
                            recordId: recordId,
                        };

                        if (_hasQueries) {
                            params.calculateQueries = true;
                        }

                        var promise = RecordsManagerService.randomize(params);

                        if (_hasQueries) {
                            promise = promise.catch(function(error) {
                                // Queries que se van a abrir al aleatorizar
                                if (error.code === 'queries-to-create') {
                                    var queryCandidates = error.info.queriesToCreate;
                                    var queries = [];
                                    angular.forEach(queryCandidates, function(query) {
                                        var fieldPath = RecordDataService.getElementFullLabeledPathByUID(query.fieldUId);
                                        queries.push({
                                            label: fieldPath.join(' > '),
                                            text: query.text,
                                        });
                                    });

                                    return Modal.open({
                                        template: 'modules/ecrd/components/rules/queries/content.html',
                                        controller: 'RulesActionCreateQueriesController',
                                        controllerAs: '$ctrl',
                                        data: {
                                            queries: queries,
                                        },
                                        onlyActions: true,
                                    }).closePromise
                                        .then(function() {
                                            // Volvemos a reintentar la aleatorización, quitando la comprobación de queries
                                            delete params.calculateQueries;

                                            return RecordsManagerService.randomize(params);
                                        });
                                }
                                else {
                                    throw error; // continuar la cadena para el log del error
                                }
                            });
                        }

                        return promise
                            .catch(function(error) {
                                if (error !== Modal.DISMISSED) {
                                    // Error message
                                    InetsysMessages.error({
                                        mode: 'modal',
                                        title: gettext('No se ha podido aleatorizar el registro'),
                                        body: ErrorMessages.get(error),
                                    });
                                }

                                throw error;
                            })
                            .then(function(recordData) {
                                RecordService.loadRecord(recordData);
                                RecordRandomizationService.load(recordData.randomization);

                                vm.isRandomized = RecordRandomizationService.isRandomized();

                                return recordData;
                            })
                            .then(function(recordData) {
                                RecordRulesService.executeAll({
                                    scope: 'update',
                                });

                                // GARU-5786 Mantenimiento del servicio de completado tras ejecutar las reglas
                                FieldsCompletionService.reload();
                                // GARU-6148 Validación tras ejecutar posibles reglas de error
                                RecordValidationService.load();

                                $rootScope.$broadcast('RecordRandomized', recordData);

                                // Recarga de información de revisión
                                if (RevisionCount) {
                                    return RevisionCount.loadFromRecord(recordId);
                                }
                            })
                            .then(function() {
                                vm.loading = false;
                            })
                            .catch(function(error) {
                                vm.loading = false;

                                if (error !== Modal.DISMISSED) {
                                    vm.error = ShareCrfApiErrorCodes.getHumanReadableMessage(error);
                                }

                                throw error;
                            });
                    }
                })
                .catch(function(error) {
                    return $exceptionHandler(error, 'randomize record');
                });
        };

        // Revelación de ciego
        vm.unblind = function() {
            vm.loading = true;
            vm.error = null;

            return Event.broadcast('unblindRecordActionStart', [recordId])
                .then(function(event) {
                    if (event.defaultPrevented) {
                        return;
                    }

                    return Modal.open({
                        templateUrl: 'modules/ecrd/components/randomization/modal-unblind.html',
                        onlyActions: true,
                    }).closePromise
                        .then(function() {
                            // 'Confirm' button clicked
                            var params = {
                                recordId: recordId,
                            };

                            return RecordsManagerService.unblind(params);
                        })
                        .then(function(data) {
                            vm.unblinded = data;
                            $rootScope.$broadcast('RecordUnblinded');

                            return _reloadRevelations();
                        })
                        .catch(function(error) {
                            if (error !== Modal.DISMISSED) {
                                vm.error = ShareCrfApiErrorCodes.getHumanReadableMessage(error);
                            }

                            throw error;
                        });
                })
                .then(function() {
                    vm.loading = false;
                })
                .catch(function(error) {
                    vm.loading = false;

                    return $exceptionHandler(error, 'unblind record');
                });
        };

        // Comprobación de bloqueo por regla: en caso de estar bloqueada la operación se coge el texto definido
        function _checkBlockedByRule() {
            vm.blockedMessage = null;

            var ruleListener = RecordRulesService.addEventListener('onBlockRandomization', function(action) {
                vm.blockedMessage = action.message;
            });

            RecordRulesService.executeAll({
                scope: 'update',
                actionType: 'blockRandomization',
            });

            RecordRulesService.removeEventListener(ruleListener);
        }


    },
]);
